import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FrontService } from '../../front.service';
import { Menu } from '../../../models/menu.model';
import { Subscription } from 'rxjs';
import { Faq } from '../../../models/faq.model';
import { FaqService } from '../../../services/faq.service';
import { FaqCategoryService } from '../../../services/faqcategory.service';
import { FaqCategory } from '../../../models/faqcategory.model';

declare var jQuery: any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FaqComponent implements OnInit {
  menus: Menu[] = [];
  subscription: Subscription;
  faqs: Faq[] = [];
  faqscategory: FaqCategory[] = [];

  accordion;

  constructor(private frontService: FrontService, private faqService: FaqService, private faqCategoryService: FaqCategoryService) { }

  ngOnInit() {
    this.frontService.loadMenu(this.menus);

    this.faqService.httpGetFaqs({
      provider: ['all', this.frontService.authService.auth.provider]
    });

    this.faqCategoryService.httpGetFaqsCategory();
    
    this.subscription = this.faqCategoryService.faqsCategoryChanged.subscribe(
      (faqscategory: FaqCategory[]) => {
        this.faqscategory = faqscategory;
      }
    );

    this.subscription = this.faqService.faqsChanged.subscribe(
      (faqs: Faq[]) => {
        this.faqs = faqs;
      }
    );

  }

  onSearch() {
    var searchTerm, panelContainerId;
    // Create a new contains that is case insensitive
    jQuery.expr[':'].containsCaseInsensitive = function (n, i, m) {
      return jQuery(n).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
    };

    searchTerm = jQuery(this).val();
    jQuery('#exampleAccordionContinuous > .panel').each(function () {
      panelContainerId = '#' + jQuery(this).attr('id');
      jQuery(panelContainerId + ':not(:containsCaseInsensitive(' + searchTerm + '))').hide();
      jQuery(panelContainerId + ':containsCaseInsensitive(' + searchTerm + ')').show();
    });
  }

  generateId(title: string) {
    return title.replace(/[^a-zA-Z0-9]/g,  '');
  }

}

 



// WEBPACK FOOTER //
// ./src/app/front/help/faq/faq.component.ts